import { render, staticRenderFns } from "./health.vue?vue&type=template&id=f278562c&scoped=true"
import script from "./health.vue?vue&type=script&lang=js"
export * from "./health.vue?vue&type=script&lang=js"
import style0 from "./health.vue?vue&type=style&index=0&id=f278562c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278562c",
  null
  
)

export default component.exports